import { TableColumnMeta } from "ds/components/Table/types";

export const AZURE_TABLE_STORAGE_KEY = "azureIntegrationsTableStorageKey";
export const AZURE_TABLE_FILTERS_STORAGE_KEY = "azureIntegrationsFiltersStorageKey";

export enum AZURE_COLUMN_ID {
  TYPE = "TYPE",
  NAME = "NAME",
  DROPDOWN = "DROPDOWN",
  SPACE = "SPACE",
}

const MAX_CELL_WIDTH = 1200;

export const AZURE_TABLE_COLUMNS_CONFIG: Record<AZURE_COLUMN_ID, TableColumnMeta> = {
  [AZURE_COLUMN_ID.TYPE]: {
    id: AZURE_COLUMN_ID.TYPE,
    title: "Type",
    minWidth: 70,
    defaultWidth: 70,
    maxWidth: 70,
    allowsSorting: false,
    resizable: false,
    canHide: true,
    configurable: true,
  },
  [AZURE_COLUMN_ID.NAME]: {
    id: AZURE_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    configurable: true,
  },
  [AZURE_COLUMN_ID.SPACE]: {
    id: AZURE_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 112,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [AZURE_COLUMN_ID.DROPDOWN]: {
    id: AZURE_COLUMN_ID.DROPDOWN,
    title: "More actions",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
  },
};

export const SORT_CONFIG: Record<AZURE_COLUMN_ID, string> = {
  [AZURE_COLUMN_ID.TYPE]: "type",
  [AZURE_COLUMN_ID.NAME]: "name",
  [AZURE_COLUMN_ID.SPACE]: "space",
  [AZURE_COLUMN_ID.DROPDOWN]: "dropdown",
};
